import { CategoryNamespace } from '@onereach/billing-dto';
export { CategoryNamespace, };
export var DataSourceProvider;
(function (DataSourceProvider) {
    DataSourceProvider["AZURE"] = "azure";
    DataSourceProvider["DRUID"] = "druid";
})(DataSourceProvider || (DataSourceProvider = {}));
//# sourceMappingURL=types.js.map